module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "news-title on-show-two"
  }, [_vm._v(_vm._s(_vm.row.title))]), _vm._v(" "), _c('div', {
    staticClass: "news-read-time"
  }, [_c('span', [_vm._v("阅读" + _vm._s(_vm.row.views_count))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.row.create_time_ago))])]), _vm._v(" "), (_vm.row.files.length > 0) ? _c('div', {
    staticClass: "fdown"
  }, [_vm._v("\n        文件下载\n        "), _vm._l((_vm.row.files), function(file, key) {
    return _c('p', {
      key: key,
      on: {
        "click": function($event) {
          return _vm.download(file)
        }
      }
    }, [_vm._v(_vm._s(file.name))])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "news-content",
    domProps: {
      "innerHTML": _vm._s(_vm.row.content)
    }
  }), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.ltActions,
      "cancel-text": "取消",
      "close-on-click-action": ""
    },
    on: {
      "select": _vm.onLtSelect,
      "cancel": function($event) {
        _vm.ltShow = false
      }
    },
    model: {
      value: (_vm.ltShow),
      callback: function($$v) {
        _vm.ltShow = $$v
      },
      expression: "ltShow"
    }
  }), _vm._v(" "), _c('van-popup', {
    style: ({
      height: '30%'
    }),
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.show_share_panel),
      callback: function($$v) {
        _vm.show_share_panel = $$v
      },
      expression: "show_share_panel"
    }
  }, [_c('div', {
    staticClass: "share-panel"
  }, [_c('div', {
    staticClass: "share-title"
  }, [_vm._v("请选择分享方式")]), _vm._v(" "), _c('div', {
    staticClass: "share-ul"
  }, [_c('div', {
    staticClass: "share-weixin",
    on: {
      "click": _vm.shareWeixinFriend
    }
  }, [_c('p', [_vm._v("微信好友")])]), _vm._v(" "), _c('div', {
    staticClass: "share-timeline",
    on: {
      "click": _vm.shareWeixinTimeLine
    }
  }, [_c('p', [_vm._v("朋友圈")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.copy_text),
      expression: "copy_text",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (function() {
        _vm.copySuccess();
        _vm.show_share_panel = false
      }),
      expression: "function(){copySuccess();show_share_panel=false }",
      arg: "success"
    }],
    staticClass: "share-copy"
  }, [_c('p', [_vm._v("复制链接")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b84e6b72","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/news/NewsDetail.vue
// module id = 1528
// module chunks = 0